<template>
  <div class="wallet-iframe-wrap">
    <iframe
      v-if="url"
      :src="url"
      frameborder="0"
      style="width:100%; height:100%;"
    ></iframe>
  </div>
</template>
<script>
export default {
  name: 'withdrawDetail',
  data () {
    return { url: undefined }
  },
  created () {
    const token = localStorage.getItem('token')
    // console.log("2222:", this.$route.params);
    const query = this.$route.params
    const baseUrl =
      currentEnv == 'dev'
        ? 'http://dev.pro.ruigushop.com'
        : currentEnv == 'test'
          ? 'https://test-pro.ruigushop.com'
          : 'https://pro.ruigushop.com'

    this.url = `${baseUrl}/${query.path}&access_token=${token}`
  }
}
</script>
<style lang="scss" scoped>
.content {
  padding: 0 !important;
}
.wallet-iframe-wrap {
  width: 100%;
  height: calc(100vh - 53px - 40px);
}
</style>



// WEBPACK FOOTER //
// src/pages/purseSetting/record/index.vue